export const TILE_FRAMES = {
  BLACK: 'black',
  WHITE: 'white',
  NONE: 'none',
}

export const TILE_TYPES = {
  FRAMED: 'framed',
  EDGE: 'classic',
}
